import { createReducer, on } from '@ngrx/store';

import { IParnersState, initialParnersState } from './parners.state';
import { ParnersLoaded } from './parners.actions';


export const initialState: IParnersState = {
  parners: []
};

const setParners = (state: IParnersState, { parners }: { parners: any[] }) => ({
  ...state,
  parners
});


const _parnersReducer = createReducer<IParnersState>(
  initialParnersState,
  on(ParnersLoaded, setParners)
);

export function parnersReducer(state: IParnersState, action): IParnersState {
  return _parnersReducer(state, action);
}
